import Vue from 'vue'
import ElementUI from 'element-ui'
// import 'babel-polyfill'
import '@/assets/styles/normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import elTableInfiniteScroll from 'el-table-infinite-scroll'
import App from './App'
import router from './router'
import store from './store'
import '@/icons'
import 'animate.css'

Vue.use(ElementUI)
Vue.use(elTableInfiniteScroll)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  Vue.prototype.$ISMOBILE = window.innerWidth <= 700

  if (!store.state.logined) {
    store.dispatch('logined').then(({data}) => {
      store.commit('setLoginState', data)
      if (data === true) {
        next()
      } else {
        store.dispatch('login').then(data => {
          window.location.href = data
        })
      }
    })
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js